var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27047_371060)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "url(#paint0_linear_27047_371060)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27047_371060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 9.33073H22.6673V22.6641H9.33398V9.33073Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27047_371060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.831 18.9326L13.0655 14.1671C12.1949 14.581 11.1254 14.4367 10.4048 13.7161C9.68427 12.9956 9.53997 11.926 9.95388 11.0555L11.5097 12.6113H12.6145V11.5064L11.0587 9.95062C11.9292 9.53672 12.9988 9.68101 13.7194 10.4016C14.4399 11.1221 14.5842 12.1917 14.1703 13.0622L18.9358 17.8277C19.8063 17.4138 20.8759 17.5581 21.5965 18.2787C22.317 18.9992 22.4613 20.0688 22.0474 20.9393L20.4916 19.3835H19.3868V20.4884L20.9426 22.0442C20.0721 22.4581 19.0024 22.3138 18.2819 21.5932C17.5614 20.8727 17.4171 19.8031 17.831 18.9326Z",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2589 17.9488L12.392 21.8158C11.7818 22.426 10.7924 22.426 10.1822 21.8158C9.57207 21.2056 9.57207 20.2163 10.1822 19.6061L14.0492 15.7391",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9438 19.0543L10.1816 21.8164",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.238 12.7601L16.5527 15.4453",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7242 9.71945L22.2766 10.2719L21.1718 12.4816L19.2383 12.7578L19.5145 10.8243L21.7242 9.71945Z",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27047_371060",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E2BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09FFC3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27047_371060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInMaintenance);
export default __webpack_public_path__ + "static/media/in-maintenance.65ddfab93ea32f6fe1c72c7b53a7a8df.svg";
export { ForwardRef as ReactComponent };